import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { getAttributes } from "../../service/Attributes/attributeService";
 
interface AttributesState {
  attributes: string[];
  loading: boolean;
  error: string | null;
  selectedAttribute: string;
}
 
const initialState: AttributesState = {
  attributes: [],
  loading: false,
  error: null,
  selectedAttribute: "",
};
 
export const fetchAttributes = createAsyncThunk(
  "attributes/fetchAttributes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAttributes();
      return response?.data.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || "Failed to fetch attributes");
    }
  }
);
 
const attributesSlice = createSlice({
  name: "attributes",
  initialState,
  reducers: {
    setSelectedAttribute: (state, action: PayloadAction<string>) => {
      // console.log("Selected Attribute:", action.payload);
      state.selectedAttribute = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttributes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttributes.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.loading = false;
        state.attributes = action.payload;
      })
      .addCase(fetchAttributes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});
export const { setSelectedAttribute } = attributesSlice.actions;
export default attributesSlice.reducer;